import { ArrowDownTrayIcon } from "components/icons/solid";

/** Shown instead of the PDF preview when the viewer cannot start (chunk, worker or PDF.js runtime failure). */
export const PdfPreviewUnavailable: React.FC<{ onDownload: () => void }> = ({ onDownload }) => (
    <div className="flex flex-wrap items-center gap-2 p-2 text-xs text-slate-500">
        <span>Preview isn't available.</span>
        <button
            type="button"
            onClick={onDownload}
            className="inline-flex items-center gap-1 font-medium text-[#2ca8de] hover:underline"
        >
            <ArrowDownTrayIcon className="h-3.5 w-3.5" />
            Download
        </button>
    </div>
);
